/**
 * Utilities that enable functional programming patterns in TypeScript.
 *
 * @remarks
 * This should be seen as a supplement to {@link https://effect.website/docs/ | effect};
 * it is not a total solution for implementing functional patterns in a TypeScript codebase.
 *
 * Additionally, some contents of this module have been migrated to
 * the {@link https://www.npmjs.com/package/@sorrell/functional | \@sorrell/functional} package.
 *
 * @module @sorrell/utilities/functional
 * @experimental
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./Functional.ts";
export * from "./Functional.Types.ts";
